$(document).ready(function(){
      $('.accordion-list > li > .answer').hide();
        
      $('.accordion-list > li > h3').click(function() {
        if ($(this).parent().hasClass("active")) {
          $(this).parent().removeClass("active").find(".answer").slideUp();
        } else {
          $(".accordion-list > li.active .answer").slideUp();
          $(".accordion-list > li.active").removeClass("active");
          $(this).parent().addClass("active").find(".answer").slideDown();
        }
        return false;
      });
      
    });